/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ShortcutsOverlay.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1738
 * ---
 * Description:
 */

import {
  Button,
  Card,
  Classes,
  Divider,
  Intent,
  Overlay,
  Tag
}                                               from '@blueprintjs/core';
import classNames                               from 'classnames';
import { currentThemeIsDark, getOS, withIcons } from '../../common/utils';
import {
  CenterBothAxes
}                                               from '../common/layout/CenterBothAxes';
import React                                    from 'react';
import { MleCombos }                            from '../../common/mle-combos';
import { OSs }                                  from '../../common/enums';

export const ShortcutsOverlay = (props: { handleClose: () => void, isOpen: boolean }) => {
  return <Overlay
    onClose={ props.handleClose }
    usePortal
    enforceFocus
    canEscapeKeyClose
    canOutsideClickClose
    isOpen={ props.isOpen }
    className={ classNames(Classes.OVERLAY_SCROLL_CONTAINER,
      { 'bp4-dark': currentThemeIsDark() }) }
  >
    <CenterBothAxes>
      <Card className="mle-center-both-axes-child mx-auto min-w-max">
        <h5 className="bp4-heading">Scorciatoie</h5>
        <Divider className="my-4"/>
        <div className="mb-2">
          Sistema operativo corrente
          <Tag
            className="ml-1"
            minimal
            intent={ Intent.PRIMARY }
          >{ getOS(true) ?? 'Non identificato (Scorciatoie Windows)' }</Tag>
        </div>
        <table className="bp4-html-table bp4-small">
          <thead>
          <tr>
            <th>Azione</th>
            <th>Combinazione</th>
          </tr>
          </thead>
          <tbody>
          {
            Object.keys(MleCombos).map(key => <tr key={ key }>
              <td>{ key }</td>
              <td className="bp4-running-text">
                { withIcons((MleCombos as any)[key][getOS() ?? OSs.WINDOWS]) }
              </td>
            </tr>)
          }
          </tbody>
        </table>
        <Divider className="my-4"/>
        <div className="mle-form-submit mt-2">
          <Button onClick={ props.handleClose }>Chiudi</Button>
        </div>
      </Card>
    </CenterBothAxes>
  </Overlay>;
};
